import api from '../utils/api';

export interface UserListRequest {
  limit?: number;
  pg?: number;
  searchKeyword?: string;
}

export interface UserRegisterRequest {
  username: string;
  phone?: string;
  loginId: string;
  password?: string;
  roleId?: number;
  teamId: number;
  dodTargetId?: number;
  kind?: string;
}

export interface UserUpdateRequest {
  username?: string;
  phone?: string;
  password?: string;
  roleId?: number;
  teamId?: number;
  dodTargetId?: number;
  kind?: string;
}

export interface UserPasswordChangeRequest {
  currentPassword: string;
  newPassword: string;
}

export interface UserInfoResponse {
  userId: number;
  username: string;
  loginId: string;
  groupId: number;
  groupName: string;
  groupDisplayName: string;
  teamId?: number;
  teamName?: string;
  phone: string;
  dodTargetId?: number;
  dodPhone?: string;
  kind?: string;
  roleName?: string;
  roleList: string[];
  permissionList: string[];
}

export interface RoleInfoResponse {
  id: number;
  role: string;
  name: string;
}

export interface PageUserInfoResponse {
  content: UserInfoResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface PhoneInfoResponse {
  id: number;
  phone: string;
  displayName: string;
}

export interface MainPhoneResponse {
  id: number;
  phone: string;
}

export interface PageMainPhoneResponse {
  content: MainPhoneResponse[];
}

export const listUsers = async (params: UserListRequest) => {
  const response = await api.get<PageUserInfoResponse>('/user', { params });
  return response.data;
};

export const getUser = async (id: number) => {
  const response = await api.get<UserInfoResponse>(`/user/${id}`);
  return response.data;
};

export const registerUser = async (data: UserRegisterRequest) => {
  const response = await api.post('/user/register', data);
  return response.data;
};

export const updateUser = async (id: number, data: UserUpdateRequest) => {
  const response = await api.put(`/user/${id}`, data);
  return response.data;
};

export const deleteUser = async (id: number) => {
  const response = await api.delete(`/user/${id}`);
  return response.data;
};

export const getRoles = async () => {
  const response = await api.get<RoleInfoResponse[]>('/user/roles');
  return response.data;
};

export const getMyInfo = async () => {
  const response = await api.get<UserInfoResponse>('/user/info');
  return response.data;
};

export const updateMyPassword = async (data: UserPasswordChangeRequest) => {
  const response = await api.put('/user/password', data);
  return response.data;
};

export const getPhones = async (isSettable?: boolean) => {
  const response = await api.get<PhoneInfoResponse[]>('/user/getPhones', { params: { isSettable } });
  return response.data;
};

export const getMainPhoneList = async () => {
  const response = await api.get<PageMainPhoneResponse>('/main-phone', { params: { limit: 100 } });
  return response.data;
};
